<script setup lang="ts">
import { useConfigCatStore } from '@/stores/configCat';

import RetryIndexing from './devTools/RetryIndexing.vue';

const configCatStore = useConfigCatStore();
</script>

<template>
    <div class="title flex flex-col gap-6">
        <div class="flex flex-col gap-2">
            <h2 class="text-xl font-semibold">Dev tools</h2>
        </div>
        <RetryIndexing v-if="configCatStore.retryIndexing" />
    </div>
</template>
